import { render, staticRenderFns } from "./ClientAttendance.vue?vue&type=template&id=0b2c5725&"
import script from "./ClientAttendance.vue?vue&type=script&lang=js&"
export * from "./ClientAttendance.vue?vue&type=script&lang=js&"
import style0 from "./ClientAttendance.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports